
<template>
  <div id="page-user-view">
    <div id="user-data" >

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
        <vx-card  class="mb-base">
          <!-- Avatar -->
          <div class="vx-row">
            <!-- Avatar Col -->
            <div class="vx-col" id="avatar-col">
              <div class="img-container mb-4">
                <img :src="photoURL" class="rounded w-full" />
              </div>
            </div>
            <div class="vx-col flex-1" id="account-info-col-1">
              <table>
                <tr>
                  <td class="font-semibold">Name:</td>
                  <td>{{ getUserInfo.name }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Email:</td>
                  <td>{{ getUserInfo.email }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">참여 수업:</td>
                  <td>{{ activeWorkspace.title }}</td>
                </tr>
              </table>
            </div>
            <div class="vx-col w-full flex" id="account-manage-buttons">
            </div>
          </div>
        </vx-card>
      </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="출결 현황" class="mb-base">
            <span v-if="getInsightUser.total_count == 0">출결 정보가 없습니다</span>
            <div slot="no-body">
              <div class="vx-row text-center">
                <div class="vx-col w-full lg:w-4/5 md:w-full sm:w-4/5 justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
                  <vue-apex-charts  autoresize type="pie" height="330" :options="attendPieChart.chartOptions" :series="attendPieChart.series"></vue-apex-charts>
                </div>
              </div>
              <!-- Support Tracker Meta Data -->
              <div class="flex flex-row justify-between px-8 pb-4 mt-2">
                <p class="text-center" >
                  <span class="block">출석</span>
                  <span class="text-2xl font-semibold">{{ attendPieChart.series[0] }}</span>
                </p>
                <p class="text-center" >
                  <span class="block">지각</span>
                  <span class="text-2xl font-semibold">{{ attendPieChart.series[1] }}</span>
                </p>
                <p class="text-center" >
                  <span class="block">결석</span>
                  <span class="text-2xl font-semibold">{{ attendPieChart.series[2] }}</span>
                </p>
              </div>
            </div>
          </vx-card>
        </div>
        <!--
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="과제 현황" class="mb-base">
            <span v-if="submitVal.labels.length == 0">과제 결과가 없습니다</span>
            <vue-apex-charts autoresize type="donut" height="350" :options="submitPieChart.chartOptions" :series="submitPieChart.series"></vue-apex-charts>
          </vx-card>
        </div> -->
      </div>

      <!-- Permissions -->
      <!-- <vx-card> -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="ClipboardIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">출결 정보</span>
            </div>
            <vs-divider  v-if="columnDefs.length == 0" />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <span v-if="columnDefs.length == 0">출결 정보가 없습니다.</span>

        </div>
      <!-- </vx-card> -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="insightVector"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>
    </div>
  </div>
</template>

<script>
// import ECharts from 'vue-echarts/components/ECharts'
// import 'echarts/lib/component/tooltip'
// import 'echarts/lib/component/legend'
// import 'echarts/lib/chart/pie'
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import VueApexCharts from 'vue-apexcharts'
import AttendAllStatus from "./cell-renderer/AttendAllStatus.vue"
// import apexChatData from './apexChartData.js'


export default {
    name: 'AttendUser',
    components: {
      AgGridVue,
      VueApexCharts,
      AttendAllStatus,
    },
    data() {
      return {
        user_data: null,
        user_not_found: false,
        themeColors: ['#28C76F', '#EA5455', '#FF9F43', '#7367F0', '#1E1E1E'],
        attendPieChart:null,
        submitPieChart:null,
        columnDefs:[],
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        gridApi: null,
        userData:[],
        gridOptions: {},
        components: {
          AttendAllStatus
        },
        submitVal: {labels:[], series:[]},
        photoURL:''
      }
    },
    computed: {
      activeUserInfo() {
        return this.$store.state.AppActiveUser
      },
      activeWorkspace() {
        return this.$store.state.space.ActiveSpaceInfo
      },
      paginationPageSize() {
        return 1
      },
      attends(){
        return this.$store.state.insight.attends
      },
      getInsightUser(){
        return this.$store.getters['insight/getInsightUser'](this.$route.params.userId)
      },
      getUserInfo(){
        return this.$store.getters['space/getMemberInfo'](this.$route.params.userId)
      },
      testResults(){
        return this.$store.state.insight.testResults
      },
      insightVector(){
        return this.$store.state.insight.insightVector
      },
      currentPage: {
        get() {
          if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      },
    },
    mounted () {
      this.gridApi = this.gridOptions.api
    },
    methods: {

    },
    beforeDestroy() {
      // this.$store.unregisterModule('insight')
      // moduleInsight.isRegistered = false
    },
    created() {
      this.photoURL = require("@/assets/images/portrait/small/" + this.getUserInfo.photo_url)
      var memeberInfo = this.$store.getters['space/getMemberInfo'](this.$route.params.userId)
      var series = [memeberInfo.attend_count, memeberInfo.miss_count, memeberInfo.late_count]
      this.attendPieChart = {series:series, chartOptions: { labels: ['출석', '결석', '지각'],  colors: this.themeColors, responsive: [{breakpoint: 480, options: { chart: { width: 150}, legend: {position: 'bottom'}}}]}}

      if(!this.attends){
        this.$store.dispatch("insight/getAttend", this.activeWorkspace.id).then(()=>{
          for(var i in this.attends){
            var attend = this.attends[i].attend
            // day = this.$moment(attend.day_time).format('MM-DD')
            this.columnDefs.push({headerName: this.$moment(attend.day_time).format('MM-DD') , field: 'attend'+i, width: 101, cellRendererFramework: 'AttendAllStatus'})
            for (var j in this.insightVector){
              var user = this.insightVector[j]
              var fildName = 'attend'+i
              if(this.attends[i].miss.find((miss) => miss.user_id == user.user_id)){
                this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:3})
              }
              else if (this.attends[i].late.find((late) => late.user_id == user.user_id)){
                this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:2})
              } else{
                this.$store.commit("insight/UPDATE_ATTEND_VECTOR", {index:j, fildName:fildName, attendVal:1})
              }
            }
          }
        })
      } else{
        for(var i in this.attends){
          var attend = this.attends[i].attend
          this.columnDefs.push({headerName: this.$moment(attend.day_time).format('MM-DD') , field: 'attend'+i, width: 101, cellRendererFramework: 'AttendAllStatus'})
        }
      }

    }
  }
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }
    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}
// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }
@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
